import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PolicyService } from '../../../service/policy.service';
import { ProcessService } from 'src/app/service/process.service';
import { ProcessModel } from 'src/app/model/process.model';
import { PolicyModel } from '../../../model/policy.model';
import { InstanceService } from 'src/app/service/instance.service';

import * as $ from "jquery";
import swal from 'sweetalert2';
import { InstanceModel } from 'src/app/model/instance.model';
import { UserService } from 'src/app/service/user.service';
import { UserModel } from 'src/app/model/user.model';
import { TaggedUserModel } from 'src/app/model/tagged-user.model';
import { EmailService } from 'src/app/service/email.service';
import { Observable } from 'rxjs';
import { AuthenticationService } from 'src/app/service/auth.service';
import { GlobalSettings } from '../../../model/settings.model';
import { DomSanitizer } from '@angular/platform-browser';
import { ValidationStrategyFactory } from 'src/app/strategy/validation-strategy.factory';
import { SortedAttributeModel } from 'src/app/model/sorted-attribute.model';
import { WorkflowGatewayService } from 'src/app/service/workflow-gateway.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AttributeModel } from '../../dynamic/model/attribute.model';
import { OptionModel } from '../../dynamic/model/option.model';
import { AttributeService } from '../../dynamic/service/attribute.service';
import { DynamicEvent } from '../../dynamic/dynamic.event';
import { ValidationResult } from 'src/app/strategy/validation-result';


declare var scrollingTabs: any;


declare var scrollingTabs: any;
// declare var $ : any;

@Component({
  selector: "app-scope",
  templateUrl: "./scope.component.html",
  styleUrls: ["./scope.component.scss"]
})

export class ScopeComponent implements OnInit {

  attribute: AttributeModel;
  comment: AttributeModel = new AttributeModel();
  processModel: ProcessModel;
  sections: AttributeModel[] = [];
  model: ProcessModel;
  listAttribute: Array<string> = [];
  policies: Array<string> = [];
  currentStep: InstanceModel;
  nameProcess: string;
  parameter: any;
  entireInstanceCopy: string;
  entireInstance: InstanceModel;
  history: SortedAttributeModel[] = [];
  task: AttributeModel;
  taskComment: AttributeModel = new AttributeModel();
  commentMaxlength: string = "2000";
  selectedUsers: TaggedUserModel[];
  steps: AttributeModel[] = [];
  pathFile: string = this.settings.processosUrl;
  versions: AttributeModel[];
  version: string;
  instance: InstanceModel = new InstanceModel();
  newInstance: InstanceModel = new InstanceModel();
  policySteps: AttributeModel[] = [];
  onPrint: boolean = false;
  historyIndex: number = 0;
  public isRecording: boolean = false;
  timelineOpened: boolean = false;
  public timeline: AttributeModel[];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private processService: ProcessService,
    private instanceService: InstanceService,
    private attrService: AttributeService,
    private emailService: EmailService,
    private authService: AuthenticationService,
    private sanitizer: DomSanitizer,
    private settings: GlobalSettings,
    private workflowApi: WorkflowGatewayService,
    private spinner: NgxSpinnerService) {}

  public headerText: Object = [{ text: 'HTML' }, { text: 'C Sharp(C#)' }, { text: 'Java' }, { text: 'VB.Net' },
    { text: 'Xamarin' }, { text: 'ASP.NET' }, { text: 'ASP.NET MVC' }, { text: 'JavaScript' }];

  get isAdmin(): boolean {
    return this.authService.hasRole("admin")
  }

  get isOwner(): boolean {
    if(this.processService.processModel) {
      let ownerUserName: string
      let sections = this.processService.processModel.attributes
        .filter(attr => attr.type.toLowerCase() == "section")

      for (const section of sections) {
        let ownerUser = section.attributes
          .find(attr => attr.type.toLowerCase() == "user")

        if(ownerUser) {
          ownerUserName = ownerUser.value
          break;
        }
      }

      if(ownerUserName) {
        let loggedUser = this.authService.getUser()

        if(loggedUser) {
          return loggedUser.userName == ownerUserName
        }
      }
    }

    return false
  }

  get hasCommentProperty(): boolean {
    if (!this.currentStep) {
      return false;
    }

    return this.comment != null;
  }

  get showDeleteButton(): boolean {
    if (!this.currentStep) {
      return false;
    }

    const showDeleteButton = this.currentStep.options
      .find(opt => opt.key.toLowerCase() == "ShowDeleteButton".toLowerCase());

    if (showDeleteButton && showDeleteButton.value.toLowerCase() == "false") {
      return false;
    }

    const showOnlyToAdmin = this.currentStep.options
      .some(opt => opt.key.toLowerCase() == "ShowDeleteButtonOnlyToAdmin".toLowerCase() && opt.value.toLowerCase() == "true");

    if (showOnlyToAdmin) {
      return this.isAdmin;
    }

    return this.isAdmin || this.isOwner;
  }

  get showDeleteButtonOnlyToAdmin(): boolean {
    if (!this.currentStep) {
      return false;
    }

    const showOnlyToAdmin = this.currentStep.options
      .some(opt => opt.key.toLowerCase() == "ShowDeleteButtonOnlyToAdmin".toLowerCase() && opt.value.toLowerCase() == "true");

    return showOnlyToAdmin;
  }

  get showHistoryButton(): boolean {
    if(!this.currentStep) {
      return false;
    }

    const historyAttr = this.currentStep.attributes
      .find(attr => attr.key.toLowerCase() == "history");

    if(historyAttr) {
      const showHistoryOpt = historyAttr.options
        .find(opt => opt.key.toLowerCase() == "ShowHistoryButton".toLowerCase());

      if(showHistoryOpt) {
        return showHistoryOpt.value.toLowerCase() == "true";
      }
    }

    return true;
  }

  get showLeftBoard(): boolean {
    return this.showTimeline || 
      this.showHistoryButton || 
      this.hasCommentProperty || 
      this.showPrintButton || 
      this.showDeleteButton
  }

  get showPrintButton(): boolean {
    if (!this.currentStep) {
      return false;
    }

    const showPrintButton = this.currentStep.options
      .some(opt => opt.key.toLowerCase() == "ShowPrintButton".toLowerCase() && opt.value.toLowerCase() == "true");

    return showPrintButton;
  }

  get showTimeline(): boolean {
    if(!this.currentStep) {
      return false;
    }

    const timelineAttr = this.currentStep.attributes
      .find(attr => attr.key.toLowerCase() == "timeline");

    if(timelineAttr) {
      const showTimelineOpt = timelineAttr.options
        .find(opt => opt.key.toLowerCase() == "ShowTimeline".toLowerCase());

      if(showTimelineOpt) {
        return showTimelineOpt.value.toLowerCase() == "true";
      }
    }

    return true;
  }

  ngOnInit() {
    // Garantir que não haja overlays residuais bloqueando cliques
    try { this.spinner.hide(); } catch (e) {}
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();

    this.route.params.subscribe(params => {
      sessionStorage.removeItem("stepCurrent");
      sessionStorage.removeItem("returnTab");
      this.processService.resetModel();
      this.sections = [];
      this.parameter = params;
      this.load();
    });
  }

  load() {
    if (this.loadParameters()) {
      this.history = [];
      this.spinner.show();

      this.processService
          .load(this.sections)
          .subscribe((processModel: ProcessModel) => {
            this.versions = processModel.versions;
            this.currentStep = this.processService.currentStep;
            this.setCommentProperty();
            this.loadAttributes(processModel);
            this.loadHistory(processModel.instance, null);
          }, (error)=> this.handleHttpError(error));
    } else {
      swal.fire("Atenção!", "Erro ao carregar a tela.", "info");
      let botao = swal.getConfirmButton();
      botao.addEventListener("click", this.navigateToDashboard.bind(this));
    }
  }

  print(){

    this.onPrint =  true;

    setTimeout(() => {
      window.print();

     this.onPrint = false;
    }, 100);
  }

  private getPolicyId(): string {
    return sessionStorage.getItem("idPolicy");
  }

  private setCommentProperty() {
    if (!this.currentStep) {
      return;
    }

    this.comment = this.currentStep.attributes.find(attr =>
      this.isInputText(attr)
    );

    if(this.comment) {
      this.comment.value = null
    }
  }

  formatHtml(value: string) {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }

  getAnyFiled(): AttributeModel[] {
    if(this.currentStep.attributes){
      let field = this.currentStep.attributes.find(attr => attr.key.toLowerCase() == "continuar")
      return field.attributes
    }
    return null

  }

  navigateToDashboard() {
    this.router.navigateByUrl("/dashboard");
  }

  loadParameters(): boolean {
    if (this.parameter.mode) {
      sessionStorage.setItem("typeDynamic", this.parameter.mode);
    } else {
      sessionStorage.removeItem("typeDynamic");
      return false;
    }

    if (this.parameter.policy) {
      sessionStorage.setItem("idPolicy", this.parameter.policy);
    } else {
      sessionStorage.removeItem("idPolicy");
      return false;
    }

    if (this.parameter.process) {
      sessionStorage.setItem("processId", this.parameter.process);
    } else {
      sessionStorage.removeItem("processId");
    }

    return true;
  }

  loadAttributes(processModel: ProcessModel) {
    this.processModel = processModel;
    this.timeline = processModel.timeline;
    this.sections.forEach(element => {
      this.listAttribute.push(element.key);
    });
    sessionStorage.setItem("policies", JSON.stringify(this.sections));
    sessionStorage.setItem("listAttribute", JSON.stringify(this.listAttribute));

    if(!sessionStorage.getItem("stepCurrent") && this.sections[0]) {
      sessionStorage.setItem("stepCurrent", this.getKey(this.sections[0].key));
    }

    setTimeout(function () {
      $(".btnView").trigger("click");
    }, 100);
  }

  private loadHistory(instance: InstanceModel, instanceId: string) {
    this.steps = [];

    if(this.entireInstanceCopy) {
      this.entireInstance = JSON.parse(this.entireInstanceCopy)
      this.fillHistory(this.entireInstance);
      this.spinner.hide();
    } else if (instance) {
      this.entireInstance = instance
      this.fillHistory(this.entireInstance);
      let sections = this.getSections();

      if(!sessionStorage.getItem("stepCurrent") && sections[0]) {
        sessionStorage.setItem("stepCurrent", this.getKey(sections[0].key));
      }

      this.spinner.hide();
    } else {
      this.instanceService
        .getByProcessId(instanceId)
        .subscribe((history: InstanceModel) => {
          if (history) {
            this.entireInstance = history
            this.fillHistory(history);
            let sections = this.getSections()

            if(!sessionStorage.getItem("stepCurrent") && sections[0]) {
              sessionStorage.setItem("stepCurrent", this.getKey(sections[0].key));
            }
          }
          this.spinner.hide();
        }, (error)=> this.handleHttpError(error));
    }
  }

  private fillHistory(instance: InstanceModel, parentName: string = "") {
    let nameAttr = instance.attributes.find(
      attr => attr.key.toLowerCase() == "name"
    );

    let nameAttrCopy: AttributeModel = {
      key: "Name",
      value: "",
      type: "Text"
    }

    let show = instance.options && !instance.options
          .some(opt => opt.key.toLowerCase() == "show" &&
                       opt.value.toLowerCase() == "false")

    if(nameAttr) {
      nameAttrCopy = this.attrService.copy(nameAttr)
      nameAttrCopy.value = `${parentName}${(show ? (parentName ? " - " : "") + nameAttrCopy.value : "")}`
    }

    instance.attributes.forEach(element => {
      if (element.type == "DateTime") {
        if (nameAttrCopy) {
          if (!element.attributes) {
            element.attributes = [];
          }

          element.attributes.push(nameAttrCopy);
        }

        let sortedItem = <SortedAttributeModel>element
        sortedItem.index = this.historyIndex

        if(!this.history.some(attr => attr.key == sortedItem.key &&
                                      attr.value == sortedItem.value)){
          this.history.push(sortedItem);
          this.historyIndex = this.historyIndex + 1
        }
      }
    });

    if(instance.childrenSteps) {
      instance.childrenSteps.forEach(childrenStep => this.fillHistory(childrenStep, nameAttrCopy.value))
    }

    if (instance.nextStep) {
      this.fillHistory(instance.nextStep);
    }
  }

  getInstanceSections(): AttributeModel[] {
    if(!this.entireInstance) {
      return []
    }

    return this.instanceService
      .getFirstLevelAttributesByType("section", this.entireInstance)
  }

  getStepClass(stepAttr: AttributeModel): string {
    let stateOpt = stepAttr.options
      .find(opt => opt.key.toLowerCase() == "state")

    if(!stateOpt) {
      return null
    }

    if (stateOpt.value == "Active" ||
        stateOpt.value == "Forked") {
      return "current";
    } else if (stateOpt.value == "Pending") {
      return "next";
    } else if (stateOpt.value == "Skipped") {
      return "skipped";
    } else if (stateOpt.value == "Completed" ||
               stateOpt.value == "Rejected") {
      return "previous";
    } else {
      return "next";
    }
  }

  getTitle(attr : AttributeModel): string {
    let titleOpt = attr.options.find(opt => opt.key.toLowerCase() == "title")
    if(titleOpt) {
        return titleOpt.value
    }
    return attr.key
  }

  getHistory(): AttributeModel[] {
    return this.history
      .sort((a, b) => (b.value <= a.value && b.index < a.index ? -1 : 1));
  }

  showStepName(index: number): boolean {
    let previousValue = this.getValueByKey(this.history[index - 1], "Name");
    let currValue = this.getValueByKey(this.history[index], "Name");

    return previousValue != currValue;
  }

  getTitleRecipient(attribute: AttributeModel): string {
    if (attribute.key == "Destinatário") {
      let recipients = attribute.value.split(",");
      return recipients != undefined
        ? recipients.length > 1
          ? "Destinatários:"
          : "Destinatário:"
        : null;
    }
    return null;
  }

  getComments(attribute: AttributeModel): AttributeModel[] {
    let comments: AttributeModel[] = [];

    for (const child of attribute.attributes) {
      if (this.isInputText(child) && child.value && child.value.trim()) {
        comments.push(child);
      }

      comments = comments.concat(this.getComments(child));
    }

    return comments;
  }

  private isInputText(attribute: AttributeModel): boolean {
    return attribute.type.toLowerCase() == "inputtext" ||
           attribute.type.toLowerCase() == "actiontext";
  }

  getCommentTooltip(): string {
    if (this.comment) {
      var tip = this.comment.options.find(
        opt => opt.key.toLowerCase() == "tooltip"
      );

      if (tip) {
        return tip.value;
      }
    }

    return "";
  }

  getEnvOptions(): OptionModel[] {
    if(!this.entireInstance) {
      return []
    }

    return [
      {
        key: "processId",
        value: this.entireInstance.processId,
        type: "id"
      },
      {
        key: "viewmode",
        value:"View",
        type:"Text"
      }
    ]
  }

  getEnvOptionsForPrint(): OptionModel[] {
    let env = this.getEnvOptions()

    env.push({
      key: "printMode",
      value: "true",
      type: "boolean"
    })

    return env
  }

  getValueByKey(
    attribute: AttributeModel,
    param: string,
    sufix: string = ""
  ): string {
    if (attribute && param) {
      var value = attribute.attributes.find(x => x.key == param);

      if (value) {
        return `${value.value}${sufix}`;
      }
    }

    return "";
  }

  geKeyByType(
    attribute: AttributeModel,
    param: string,
    sufix: string = ""
  ): string {
    let key: string = "";
    attribute.attributes.forEach(attr => {
      if (attr.type == param) {
        let historyLabel = attr.options.find(
          opt => opt.key.toLowerCase() == "history-label"
        );

        if (historyLabel) {
          key = historyLabel.value;
        } else {
          key = attr.key;
        }

        key += sufix;
      }
    });

    return key;
  }

  getAttributeByKey(attribute: AttributeModel, param: string): AttributeModel {
    let atributes;

    if (attribute != null) {
      attribute.attributes.forEach(element => {
        if (element.key == param) {
          atributes = element;
        }
      });
    }

    return atributes != undefined ? atributes : null;
  }

  getAttributeByType(attribute: AttributeModel, param: string): AttributeModel {
    let atributes;

    attribute.attributes.forEach(element => {
      if (element.type == param) {
        atributes = element;
      }
    });

    return atributes != undefined ? atributes : null;
  }

  getKey(str: string): string {
    return str
      .trim()
      .split(" ")
      .join("_");
  }

  execute(task: AttributeModel) {
    $("#actionComment").removeClass("has-error");
    $(".has-error-text").addClass("hide");

    this.task = task;
    let inputText = this.task.attributes.find(attr => this.isInputText(attr));

    if (inputText) {
      let maxlengthOpt = inputText.options.find(opt => opt.key == "maxlength");

      if (maxlengthOpt) {
        this.commentMaxlength = maxlengthOpt.value;
      }

      this.taskComment = inputText;
      (window as any).$("#parecerAR").modal("show");
    } else {
      this.sendTask();
    }
  }

  getCurrentStepName(): string {
    if (!this.currentStep) return;

    let name = this.currentStep.attributes.find(
      attr => attr.key.toLowerCase() == "name"
    );

    if (name) return name.value;
  }

  getOptionValueByKey(attribute: AttributeModel, key: string): string {
    let opt = attribute.options.find(
      opt => opt.key.toLowerCase() == key.toLowerCase()
    );

    if (opt) {
      return opt.value;
    }

    return "";
  }

  getQuestion(): string {
    return `Deseja ${this.getTaskKey()}?`;
  }

  getTaskKey(): string {
    if (!this.task) {
      return "";
    }

    let titleOpt = this.task.options.find(
      opt => opt.key.toLowerCase() == "title"
    );
    if (titleOpt) {
      return titleOpt.value;
    }
    return this.task.key;
  }


  getTitleModal(): string {
    let titleOpt = this.taskComment.options.find(
      opt => opt.key.toLowerCase() == "title");

    if (titleOpt) {
      return titleOpt.value;
    } else if(this.task) {
      let taskTitleOpt = this.task.options
        .find(opt => opt.key.toLowerCase() == "title")

      if(taskTitleOpt) {
        return `Deseja ${taskTitleOpt.value}?`
      } else {
        return `Deseja ${this.task.key}?`
      }
    }
  }

  getSections(): AttributeModel[] {
    if(!this.sections) {
      return []
    }
    return this.activateCurrentStepSection(this.sections);
  }

  private activateCurrentStepSection(attrs: AttributeModel[]): AttributeModel[] {
    if(attrs.length == 0){
      return attrs;
    }
    attrs.forEach(attr => attr.isActive = false);

    const returnTab = sessionStorage.getItem("returnTab");

    let currentStepFirstSection = this.currentStep?.attributes
      .find(attr => attr.type.toLowerCase() == "section" &&
                    attr.attributes.length > 0);

    if (returnTab) {
      const returnSection = attrs.find(attr => 
        this.getKey(attr.key).toLowerCase() == returnTab.toLowerCase());

      if (returnSection) {
        returnSection.isActive = true;
      }
    } else if (currentStepFirstSection) {
      let foundSection = attrs.find(attr => 
        this.getKey(attr.key).toLowerCase() == this.getKey(currentStepFirstSection.key).toLowerCase());

      if(foundSection){
        foundSection.isActive = true;
      }
    } else {
       attrs[0].isActive = true;
    }
    return attrs;
  }

  getButtonsFromCurrentStep(): AttributeModel[] {
    if(this.currentStep) {
      return this.currentStep.attributes
        .filter(attr => attr.type.toLowerCase() == "ButtonLink".toLowerCase())
    }

    return []
  }

  getTasksOfCurrentStep(): AttributeModel[] {
    if (!this.currentStep) return;

    return this.getTasksOfStep(this.currentStep);
  }

  getTasksOfStep(step: InstanceModel): AttributeModel[] {
    let allTasks: AttributeModel[] = []
    this.addTasksToList(allTasks, step.attributes)

    for (const child of step.childrenSteps) {
      allTasks = allTasks.concat(this.getTasksOfStep(child))
    }

    if(step.nextStep) {
      allTasks = allTasks.concat(this.getTasksOfStep(step.nextStep))
    }

    return allTasks;
  }

  getViewModeOption(attribute: AttributeModel): OptionModel {
    let viewOpt = attribute.options.find(opt => opt.key == "ViewMode")

    if(viewOpt) {
      return viewOpt
    }

    return {
      key: "ViewMode",
      value: "View",
      type: "Text"
    }
  }

  hasTask(){
    if (!this.currentStep) return false;

    let allTasks: AttributeModel[] = [];
    this.addTasksToList(allTasks, this.currentStep.attributes);

    for (const step of this.currentStep.childrenSteps) {this.addTasksToList(allTasks, step.attributes);}

    return allTasks.length <= 0 ? false : true;
  }

  private addTasksToList(
    allTasks: AttributeModel[],
    originList: AttributeModel[]
  ) {
    for (const task of this.getTasksFromList(originList)) {
      allTasks.push(task);
    }
  }

  private getTasksFromList(attributes: AttributeModel[]): AttributeModel[] {
    return attributes.filter(
      attr =>
        (attr.type.toLowerCase() == "task" ||
         attr.type.toLowerCase() == "actionbutton") &&
        !attr.options.some(
          opt => opt.key.toLowerCase() == "view" && opt.value == "hide"
        )
    );
  }

  hasInputText(): boolean {
    return (
      this.taskComment &&
      this.taskComment.key &&
      this.isInputText(this.taskComment)
    );
  }

  hasParecer() : boolean {

    if (this.task){
      if (this.attrService.findBy("Opinião Parecer", this.task.attributes)){
        return true;
      }else{
        return false;
      }

    }

    return false;
  }

  hasVersions(): boolean {
    return this.versions && this.versions.length > 0;
  }

  onChangeToCurrent() {
    this.version = null;
    this.entireInstanceCopy = null;
    this.load();
  }

  onChangeVersion(attribute: AttributeModel) {
    if (
      !attribute ||
      (this.version && this.version == `VERSÃO: ${attribute.key}`)
    ) {
      return;
    }

    this.spinner.show();

    if(!this.version) {
      this.entireInstanceCopy = JSON.stringify(this.entireInstance)
    }

    this.processService.getVersion(attribute.key).subscribe(processModel => {
      this.version = `VERSÃO: ${attribute.key}`;
      this.spinner.hide();
    });

    this.instanceService.getVersion(attribute.key).subscribe(instanceModel => {
      this.entireInstance = instanceModel
    })
  }

  onDelete() {
    swal.fire({
      title: 'Atenção',
      text: "Deseja realmente excluir?",
      icon: 'info',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Não',
      confirmButtonText: 'Sim'
    }).then((result) => {
      console.log(result);
      if (result.value) {
        this.delete();
      }
    })
  }

  onExecuteRequest(attributes: AttributeModel[]) {
    let taskEvent = attributes
      .find(attr => attr.type.toLowerCase() == "task" ||
                    attr.type.toLowerCase() == "toggletask" ||
                    attr.type.toLowerCase().startsWith("action"))

    this.task = taskEvent

    if(this.task) {
      const inputText = this.task.attributes && this.task.attributes.find(attr => this.isInputText(attr));

      if (inputText) {
        const maxlengthOpt = inputText.options && inputText.options.find(opt => opt.key == "maxlength");
        if (maxlengthOpt) {
          this.commentMaxlength = maxlengthOpt.value;
        }
        this.taskComment = inputText;
        (window as any).$("#parecerAR").modal("show");
      } else {
        this.sendTask();
      }
    }
  }

  onSectionEmit(events: DynamicEvent[]) {
    events.forEach(event => {
      if(event.name == "save and update" || event.name == "update") {
        let newSections: AttributeModel[] = [];
        
        let timeout = setTimeout(() => {
          this.spinner.show();
        }, 400);

        this.processService.load(newSections)
          .subscribe((processModel) => {
            clearTimeout(timeout);
            this.versions = processModel.versions;
            this.currentStep = this.processService.currentStep;
            this.sections = newSections;
            this.loadAttributes(processModel);
            this.spinner.hide();
          }, (error) => {
            clearTimeout(timeout);
            this.handleHttpError(error)
          })
      }
    })
  }

  private delete() {
    this.workflowApi.deleteProcess(this.processService.processModel.id)
      .subscribe(() => {
        this.navigateToDashboard()
      }, (error)=> this.handleHttpError(error))
  }

  preventDefaultLink(event: Event) {
    event.preventDefault();
  }

  selectTab(key: string) {
    sessionStorage.setItem("stepCurrent", this.getKey(key));
  }

  sendComment() {
    this.comment.attributes = [];
    let comment = $("#txtComment").val();
    this.comment.value = comment.toString();

    if (this.comment && this.comment.value) {
      if (this.selectedUsers && this.selectedUsers.length > 0) {
        let recipient: AttributeModel = new AttributeModel();
        recipient.key = "Destinatário";
        recipient.value = "";
        recipient.type = "InputText";
        this.selectedUsers.forEach(element => {
          recipient.value = recipient.value + element.name + ",";
        });
        recipient.value = recipient.value.substring(
          0,
          recipient.value.length - 1
        );

        this.comment.attributes.push(recipient);
      }

      $("#txtComment").removeClass("has-error");
      $(".has-error-text").addClass("hide");

      this.spinner.show();

      this.instanceService
        .executeById(this.processService.processModel.id, [this.comment])
        .subscribe((processModel: ProcessModel) => {
          swal.hideLoading();
          this.currentStep = processModel.currentStep;
          $(".parecer").trigger("click");
          swal.fire("Sucesso!", `Comentário enviado com sucesso.`, "success");
          this.history = [];
          this.loadHistory(processModel.instance, null);

          if (this.selectedUsers && this.selectedUsers.length > 0) {
            this.sendEmail().subscribe(() => {
              this.selectedUsers = [];
            }, (error)=> this.handleHttpError(error));
          }

          this.comment.value = "";
        }, (error)=> this.handleHttpError(error));
    } else {
      $("#txtComment").addClass("has-error");
      $(".has-error-text").removeClass("hide");
    }
  }

  private sendEmail(): Observable<AttributeModel> {
    let email = new AttributeModel();
    email.key = "email";
    email.value = "Você foi mencionado em um comentário.";
    email.type = "text";

    let content = new AttributeModel();
    content.key = "content";
    content.value = `<b>Comentário de ${this.authService.getUser().name}: </b><p>${
      this.comment.value
      }</p>`;
    content.type = "text";
    email.attributes.push(content);

    let link = new AttributeModel();
    link.key = "Complemento";
    link.value = `processes/scope/view/${this.getPolicyId()}/${
      this.currentStep.processId
      }`;
    link.type = "link";
    email.attributes.push(link);

    for (const userName of this.selectedUsers) {
      let recipient = new AttributeModel();
      (recipient.key = "recipient"),
        (recipient.value = userName.id),
        (recipient.type = "user");

      email.attributes.push(recipient);
    }

    return this.emailService.send(email);
  }

  sendTask() {
    let skipValidation = this.task.type
      .toLowerCase()
      .startsWith("action");

    let parecer = $("#actionComment").val();

    if (parecer) this.taskComment.value = parecer.toString();

    if (this.validTaskComment()) {
      $("#actionComment").removeClass("has-error");
      $(".has-error-text").addClass("hide");

      const previousStepName = this.getCurrentStepName();

      let inputText = this.task.attributes.find(
        attr => attr.type.toLowerCase() == "inputtext"
      );

      if (inputText) {
        inputText.value = this.taskComment.value;
      }

      if(this.version) {
        this.entireInstance = JSON.parse(this.entireInstanceCopy)
      }

      if (!skipValidation) {
        const validationResult = this.validateRequired();

        if(!validationResult.isValid) {
          swal.fire('Atenção', validationResult.errorMessage 
            ? validationResult.errorMessage 
            : 'Existem campos obrigatórios não preenchidos', 'warning');

          return;
        }
      }

      this.spinner.show();

      let requestAttributes: AttributeModel[] = []
      requestAttributes.push(this.task)

      let section = this.currentStep.attributes
        .find(attr => attr.type.toLowerCase() == "section")

      if(section) {
        let foundSection = this.sections.find(attr => 
          attr.key.toLowerCase() == section.key.toLowerCase())
  
        if(foundSection) {
          requestAttributes = requestAttributes
            .concat(foundSection.attributes.filter(attr => !attr.options
              .some(opt => opt.key.toLowerCase() == "viewmode" && opt.value.toLowerCase() == "view")))
        }
      }

      this.instanceService
        .executeById(this.processService.processModel.id, requestAttributes)
        .subscribe((processModel: ProcessModel) => {
          swal.hideLoading();
          this.currentStep = processModel.currentStep;
          const newStepName = this.getCurrentStepName();
          if (previousStepName !== newStepName) {
            sessionStorage.removeItem('returnTab');
            // opcional: ajustar stepCurrent para a primeira seção da nova fase
            const firstSection = this.currentStep?.attributes?.find(a => a.type.toLowerCase() === 'section');
            if (firstSection) {
              sessionStorage.setItem('stepCurrent', this.getKey(firstSection.key));
            }
          }
          (window as any).$("#parecerAR").modal("hide");
          swal.fire("Sucesso!", `Tarefa ${this.getAttributeTitle(this.task)} realizada.`, "success");
          this.taskComment = new AttributeModel();
          this.history = [];
          this.sections = [];
          this.processService.updatePolicy(processModel, this.sections);
          this.loadHistory(processModel.instance, null);
          this.postRedirect()
          this.timeline = processModel.timeline;
        }, (error)=>{
          $('body').removeClass('modal-open');
          $('.modal-backdrop').removeClass('fade');
          $('.modal-backdrop').removeClass('show');
          $('.modal-backdrop').removeClass('modal-backdrop');
          this.handleHttpError(error)
        });
    } else {
      $("#actionComment").addClass("has-error");
      $(".has-error-text").removeClass("hide");
    }
  }

  private postRedirect(){
    let redirectAttr = this.task.options.find(o => o.key.toLowerCase() == 'postredirect')
    if(redirectAttr){
      this.router.navigate(['/processes/process/' + redirectAttr.value + '/' +
        this.processService.processModel.policyId + '/' + this.processService.processModel.id])
    }
  }

  private validTaskComment(): boolean {
    let isValid = true;
    let inputText = this.task.attributes.find(
      attr => attr.type.toLowerCase() == "inputtext"
    );

    if (inputText) {
      let required = inputText.options.find(
        opt => opt.key.toLowerCase() == "required"
      );

      if(required){
        let requiredValue = required.value.toLowerCase() == "true";
        isValid = !requiredValue || this.taskComment.value ? true : false;
      }
    }
    return isValid;
  }

  private validateRequired(): ValidationResult {
    let validationResult = {
      isValid: true,
      errorMessage: ""
    }

    let selectedSections = [];

    const currentStepSections = this.currentStep.attributes
        .filter(attr => attr.type.toLowerCase() == "section");

    if(currentStepSections.length > 0) {
      selectedSections = this.sections.filter(attr => 
        currentStepSections.some(section => attr.key.toLowerCase() === section.key.toLowerCase())
      );
    }

    if(!selectedSections || selectedSections.length == 0) {
      return validationResult;
    }

    let validatingAttributes = []
    
    selectedSections.forEach(attr => {
      validatingAttributes = validatingAttributes.concat(attr.attributes)
    });

    validatingAttributes = JSON.parse(
      JSON.stringify(validatingAttributes)
    )

    for (const attribute of validatingAttributes) {
      let strategy = ValidationStrategyFactory.create(attribute)

      let result = strategy.validate()

      if(!result) {
          validationResult.errorMessage += `${strategy.getErrorMessage()}\n`;
          validationResult.isValid = false
      }
    }

    return validationResult;
  }

  private getAttributeTitle(attribute: AttributeModel): string {
    let titleOpt = attribute.options.find(opt => opt.key.toLowerCase() == "title")

    if(titleOpt) {
        return titleOpt.value
    }

    return attribute.key
  }

  ngConverDate(data: string): string {
    var returnDate = "";

    var date = data.split("T")[0].replace(/-/g, "/");
    var today = new Date(date);
    //split
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //because January is 0!
    var yyyy = today.getFullYear();
    var hours = today.getHours();
    var minutes = today.getMinutes();
    var seconds = today.getSeconds();
    //Interpolation date
    if (dd < 10) {
      returnDate += `0${dd}/`;
    } else {
      returnDate += `${dd}/`;
    }

    if (mm < 10) {
      returnDate += `0${mm}/`;
    } else {
      returnDate += `${mm}/`;
    }
    returnDate += yyyy + " ";

    if (hours < 10) {
      returnDate += `0${hours}:`;
    } else {
      returnDate += `${hours}:`;
    }

    if (minutes < 10) {
      returnDate += `0${minutes}:`;
    } else {
      returnDate += `${minutes}:`;
    }

    if (seconds < 10) {
      returnDate += `0${seconds}`;
    } else {
      returnDate += `${seconds}`;
    }

    return returnDate;
  }

  versionIsSelected(): boolean {
    return this.version && this.version != "";
  }

  onMaxlength(event: any) {
    if (event.composedPath.length > this.commentMaxlength) {
      return false;
    }
  }

  private handleHttpError(error: any) {
    this.spinner.hide();

    if(error.status == 401) {
      this.authService.logout()
      this.router.navigate(['login']);
    } else if(error.status == 403) {
      swal.fire("Atenção", "Este usuário não tem permissão para acessar este conteúdo.")
        .then(() => this.router.navigate([""]).then(() => swal.close()))
    } else if(error.message) {
      swal.fire("Atenção", error.message, "error").then(() => {
        if(error.goBackToHome) {
          this.router.navigate([""]).then(() => swal.close())
        }
      })
    } else {
      swal.fire("Atenção", "Algo errado aconteceu; Por favor, tente novamente.", "error")
    }
  }
}
